import React, { useState } from "react";
import { Button, Checkbox, Form, Input, Alert } from "antd";
import { Link } from "react-router-dom";
import { useTranslation } from "../../i18n/LanguageContext";
import "./style.css";
import API_URL from "../../apiBase";

const Feedback = () => {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState(null);

    const onFinish = async (values) => {
        setLoading(true);
        setError(null);
        try {
            const res = await fetch(`${API_URL}/api/feedback`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    fullName: values.fullName,
                    mobileNumber: values.mobileNumber,
                    email: values.email,
                    message: values.message,
                }),
            });
            const data = await res.json().catch(() => null);
            if (!res.ok) {
                throw new Error((data && data.error) || t("feedback.error"));
            }
            setSubmitted(true);
            form.resetFields();
        } catch (err) {
            setError(err.message || t("feedback.error"));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="main-content-wrapper">
            <div className="feedback-container">
                <div className="feedback-card">
                    <h2>{t("feedback.title")}</h2>
                    <p className="feedback-lead">{t("feedback.lead")}</p>

                    {submitted && (
                        <Alert
                            className="feedback-alert"
                            type="success"
                            showIcon
                            message={t("feedback.success")}
                            closable
                            onClose={() => setSubmitted(false)}
                        />
                    )}

                    {error && (
                        <Alert
                            className="feedback-alert"
                            type="error"
                            showIcon
                            message={error}
                            closable
                            onClose={() => setError(null)}
                        />
                    )}

                    <Form
                        form={form}
                        name="feedback"
                        onFinish={onFinish}
                        autoComplete="off"
                        size="large"
                        layout="vertical"
                        requiredMark={false}
                    >
                        <Form.Item
                            label={t("feedback.name")}
                            name="fullName"
                            rules={[
                                {
                                    required: true,
                                    message: t("feedback.name.required"),
                                },
                            ]}
                        >
                            <Input placeholder={t("feedback.name")} />
                        </Form.Item>
                        <Form.Item
                            label={t("feedback.phone")}
                            name="mobileNumber"
                            rules={[
                                {
                                    required: true,
                                    message: t("feedback.phone.required"),
                                },
                                {
                                    pattern: /^[+\d][\d\s()-]{6,}$/,
                                    message: t("feedback.phone.invalid"),
                                },
                            ]}
                        >
                            <Input placeholder="+374 XX XXX XXX" />
                        </Form.Item>
                        <Form.Item
                            label={t("feedback.email")}
                            name="email"
                            rules={[
                                {
                                    required: true,
                                    message: t("feedback.email.required"),
                                },
                                {
                                    type: "email",
                                    message: t("feedback.email.invalid"),
                                },
                            ]}
                        >
                            <Input placeholder="you@example.com" />
                        </Form.Item>
                        <Form.Item
                            label={t("feedback.message")}
                            name="message"
                            rules={[
                                {
                                    required: true,
                                    message: t("feedback.message.required"),
                                },
                            ]}
                        >
                            <Input.TextArea
                                rows={5}
                                placeholder={t("feedback.message.placeholder")}
                            />
                        </Form.Item>

                        <Form.Item
                            name="readPolicy"
                            valuePropName="checked"
                            rules={[
                                {
                                    validator: (_, value) =>
                                        value
                                            ? Promise.resolve()
                                            : Promise.reject(
                                                  new Error(
                                                      t(
                                                          "feedback.policy.required"
                                                      )
                                                  )
                                              ),
                                },
                            ]}
                        >
                            <Checkbox>
                                {t("feedback.policy")}{" "}
                                <Link to="/PrivacyPolicy">
                                    {t("feedback.policy.link")}
                                </Link>
                            </Checkbox>
                        </Form.Item>

                        <Form.Item>
                            <Button
                                block
                                type="primary"
                                htmlType="submit"
                                loading={loading}
                            >
                                {t("feedback.submit")}
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </div>
        </div>
    );
};

export default Feedback;
